import { render, staticRenderFns } from "./bet-history-detail.vue?vue&type=template&id=0f309ef1&scoped=true"
import script from "./bet-history-detail.vue?vue&type=script&lang=js"
export * from "./bet-history-detail.vue?vue&type=script&lang=js"
import style0 from "./bet-history-detail.vue?vue&type=style&index=0&id=0f309ef1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f309ef1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f309ef1')) {
      api.createRecord('0f309ef1', component.options)
    } else {
      api.reload('0f309ef1', component.options)
    }
    module.hot.accept("./bet-history-detail.vue?vue&type=template&id=0f309ef1&scoped=true", function () {
      api.rerender('0f309ef1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/bet-history-detail.vue"
export default component.exports